import { render, staticRenderFns } from "./AssignedOrderDetails.vue?vue&type=template&id=0200567e&scoped=true&"
import script from "./AssignedOrderDetails.vue?vue&type=script&lang=js&"
export * from "./AssignedOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssignedOrderDetails.vue?vue&type=style&index=0&id=0200567e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0200567e",
  null
  
)

export default component.exports